module.exports = require('./_global').document && document.documentElement;


/*****************
 ** WEBPACK FOOTER
 ** C:/wamp/www/~/core-js/modules/_html.js
 ** module id = 42
 ** module chunks = 0
 **/